module.exports = __webpack_public_path__ + "static/forest-d0877bd3117ef75262f456680fd51f2b.svg";